import BigNumber from 'bignumber.js';
import _clamp from 'lodash/clamp';

export const PERCENT_ALLOCATION_STEP: number = 0.1;

export const roundAllocationSettingsPercentToNearestStep = (v: number): number => {
	const value: number = _clamp(v || 0, 0, 100);
	return new BigNumber(value)
		.div(PERCENT_ALLOCATION_STEP)
		.integerValue(BigNumber.ROUND_HALF_UP)
		.times(PERCENT_ALLOCATION_STEP)
		.toNumber();
};

export const updateTeamTokenAllocationSettings = async (
	functionRef,
	teamDatas: {
		teamId: string
		monthlyRunnitTokensBudget: number
		isBoundToBudget: boolean
	}[],
): Promise<void> => {
	if (!teamDatas?.length) return;

	const payloadData = {
		teamDatas: teamDatas.map(teamData => ({
			...teamData,
			monthlyRunnitTokensBudget: Math.max(0, teamData.monthlyRunnitTokensBudget),
			isBoundToBudget: !!teamData.isBoundToBudget,
		})),
	};
	const { success, message } = (await functionRef(payloadData)).data;

	if (!success) {
		throw new Error(message || 'Error saving token allocations');
	}
};
